import { render, staticRenderFns } from "./BookingOverviewDemo.vue?vue&type=template&id=36a37b74&scoped=true&"
import script from "./BookingOverviewDemo.vue?vue&type=script&lang=js&"
export * from "./BookingOverviewDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a37b74",
  null
  
)

export default component.exports